import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID, REQUEST_CONTEXT } from '@angular/core';

import { getNormalizedRoute } from '../../feature/routing/routing.utils';
import { EnvironmentService } from '../environment/environment.service';

export const statsdRouteResolve: ResolveFn<void> = (snapshot: ActivatedRouteSnapshot): void => {
	if (isPlatformBrowser(inject(PLATFORM_ID))) return;

	const environment = inject(EnvironmentService);
	if (environment.store.includes('localhost') || !environment.store) return;

	inject<{ request: Request & { accessoStatsdTags: Record<string, unknown> } }>(REQUEST_CONTEXT).request.accessoStatsdTags['route'] =
		'/' + getNormalizedRoute(snapshot.root);
};
